import React, { useEffect, useState } from "react";

import Navbar from "./AdminNavBar";
import Footer from "./Footer";
import { RightMenu } from "./RightMenu";

import { useSelector, useDispatch } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router";

import { logoutSuccess } from "../state/authRedux";

import { FaUserCircle } from "react-icons/fa";
import { HiOutlineLogout } from "react-icons/hi";

const Layout = ({ children }) => {
    const [inactiveTimer, setInactiveTimer] = useState(null);
    const navigate = useNavigate();
    const user = useSelector((state) => state.user.currentUser);
    const [open, setOpen] = useState(false);
    const highlight = useSelector((state) => state.highlight.index);
    const dispatch = useDispatch();

    const logout = () => {
        dispatch(logoutSuccess());
        navigate('/login');
    };

    // rest of your code...

    return (
    user && user.data.isAuthenticated ?
        <div className="h-screen w-full flex overflow-hidden bg-[#030527]">

            <Navbar 
                open={open} 
                setOpen={setOpen} 
                highlight={highlight}
            />

            <div
                className="
                    flex-1
                    h-screen
                    overflow-y-auto
                    bg-[#030527]
                    bg-precision
                    text-sm
                    font-semibold
                    duration-300
                    ease-in-out
                "
            >
                <Outlet />
            </div>

        </div>
    :
        <Navigate to="/login" />
);
};

export default Layout;